/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Bitten Sie Ihr Team oder Ihren Administrator um Unterstützung.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Für diese Suche konnten keine Ergebnisse abgerufen werden',
};
